import request from './request';

export default {
	getAll(query) {
		return request.get('/template-connections', query);
	},

	create(body) {
		return request.post('/template-connections', body);
	},

	update(id, templateConnection) {
		return request.patch(`/template-connections/${id}`, {
			template_connection: templateConnection
		});
	},

	updateBatch(templateConnections) {
		return request.patch('/template-connections/batch', {
			template_connections: templateConnections
		});
	}
};



// WEBPACK FOOTER //
// ./src/helpers/chated-client/template-connection.js